import { render, staticRenderFns } from "./ContactInfo.vue?vue&type=template&id=f6d02b7c&scoped=true"
import script from "./ContactInfo.vue?vue&type=script&lang=js"
export * from "./ContactInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d02b7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6d02b7c')) {
      api.createRecord('f6d02b7c', component.options)
    } else {
      api.reload('f6d02b7c', component.options)
    }
    module.hot.accept("./ContactInfo.vue?vue&type=template&id=f6d02b7c&scoped=true", function () {
      api.rerender('f6d02b7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/purchaseService/components/sections/ContactInfo.vue"
export default component.exports